import React from 'react';
import { motion } from 'framer-motion';
import { SlideLayout, itemVariants } from '../ui/SlideLayout';
export function AppendixCoverSlide() {
  return <SlideLayout className="text-center relative" data-id="element-101">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] bg-brand-teal/5 blur-[100px] rounded-full pointer-events-none" data-id="element-102" />

      <motion.div variants={itemVariants} data-id="element-103">
        <h2 className="text-6xl md:text-8xl font-bold text-brand-text tracking-tight mb-6" data-id="element-104">
          Appendix
        </h2>
        <p className="text-xl text-brand-text-dim max-w-xl mx-auto" data-id="element-105">
          Technical deep dives, market context, and pricing details for
          follow-up conversations.
        </p>
      </motion.div>
    </SlideLayout>;
}